import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=b028731e&"
import script from "./SendList.vue?vue&type=script&lang=ts&"
export * from "./SendList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports